import React from 'react';
import { useMutation } from 'react-query';

/**
 * a hoc that connects a component to a react-query mutation
 * @param {object} config - config
 * @param {function} config.mutationFn - async function that performs the mutation - api call
 * @param {object} [config.mutationOptions={}] - optional options to pass directly to useMutation (onSuccess, onError...)
 * @param {function} config.mapMutationToProps - a function to map the mutation state and actions to props for the wrapped component
 */
export function withMutation(config) {
    const {
        mutationFn,
        mutationOptions = {},
        mapMutationToProps,
    } = config;

    return function (WrappedComponent) {
        const WithMutation = (props) => {
            const mutationResult = useMutation(mutationFn, mutationOptions);

            const newProps = mapMutationToProps(
                mutationResult.mutateAsync,
                mutationResult,
                props,
            );

            return <WrappedComponent {...props} {...newProps} />;
        };

        return WithMutation;
    };
}



// WEBPACK FOOTER //
// ./app/HOC/common.js